import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Option} from "../../../domain/select/option";

@Component({
  selector: 'selector-multiple',
  templateUrl: './multioption.component.html',
  styleUrls: ['./multioption.component.scss']
})
export class MultioptionComponent implements OnInit {
  @Input('title')title:string;
  @Input('list')list: any;
  @Input('seleccion')seleccion?: any;
  @Output('result')resultado = new EventEmitter<Option[]>();
  dropdownSettings;
  constructor() { }

  ngOnInit() {
      this.dropdownSettings = {
          singleSelection: false,
          idField: 'id',
          textField: 'nombre',
          selectAllText: 'Seleccionar todas las opciones',
          unSelectAllText: 'Deseleccionar',
          itemsShowLimit: 100,
          allowSearchFilter: true,
          enableCheckAll: true
      };
  }
    onItemSelect(item: any ) {
        this.seleccion.push(item);
        this.toForm();
    }
    onItemDeSelect(item: any ) {
        this.seleccion = this.seleccion.filter(value => item.id !== value.id);
        this.toForm();
    }
    toForm(){
      this.resultado.emit(this.seleccion);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/selects/multioption/multioption.component.ts